/**
 * AlmadarPostContextCompactionENPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostContextCompactionENPostPage
 */

import { useAlmadarPostContextCompactionENPostPageLogic } from '@/hooks/traits/useAlmadarPostContextCompactionENPostPageLogic';
import type { AlmadarPostContextCompactionENPostPageConfig } from '@/hooks/traits/useAlmadarPostContextCompactionENPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostContextCompactionENPostView as AlmadarPostContextCompactionENPostViewEntity } from '@app/shared';
import { AlmadarPostContextCompactionENPostHeaderView } from '@/components/traits/AlmadarPostContextCompactionENPostHeaderView';
import { Container } from '@almadar/ui/components';
import { AlmadarPostContextCompactionENPostFooterView } from '@/components/traits/AlmadarPostContextCompactionENPostFooterView';
import { AlmadarPostContextCompactionENPostView } from '@/components/traits/AlmadarPostContextCompactionENPostView';
import { Box } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostContextCompactionENPostPageViewProps {
  config?: Partial<AlmadarPostContextCompactionENPostPageConfig>;
}

export function AlmadarPostContextCompactionENPostPageView({ config: propsConfig }: AlmadarPostContextCompactionENPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostContextCompactionENPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostContextCompactionENPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostContextCompactionEN" trait="AlmadarPostContextCompactionENPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostContextCompactionENPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostContextCompactionENPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box bg="transparent" paddingY="xl" fullWidth={true}><Container maxWidth="xl" size="xl" padding="lg"><AlmadarPostContextCompactionENPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostContextCompactionENPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostContextCompactionENPostPageView;
